module.exports = __webpack_public_path__ + "img/gst.b3282a76.png";